import { useMemo } from "react"
import { useLabels } from "../../../contents/hooks"
import { BasketSample } from "../types/basket"

export const useBasketSamples = (): BasketSample[] => {
  const { getLabel } = useLabels()
  return useMemo(
    () => [
      {
        id: "sample1",
        name: getLabel("basket", "samples-man"),
      },
      {
        id: "sample2",
        name: getLabel("basket", "samples-woman"),
      },
    ],
    []
  )
}
